/**
 * Vuex store module for department management.
 *
 * @module store/modules/department
 * @description Manages state for organizational departments used in access control and
 * chat routing. Supports CRUD operations for department configuration including metadata.
 *
 * @example
 * // Access state
 * this.$store.state.department.departments
 *
 * // Dispatch action
 * this.$store.dispatch('FETCH_DEPARTMENTS')
 *
 * // Add department
 * this.$store.dispatch('ADD_DEPARTMENT', { department: { name, description, meta } })
 */
import actions from "./actions";
import getters from "./getters";
import mutations from "./mutations";
import state from "./state";
import { Module } from "vuex/types";
import { DepartmentState } from "./types";
import { RootState } from "@/store/types";

const Department: Module<DepartmentState, RootState> = {
  // namespaced: true,
  actions,
  getters,
  mutations,
  state,
};

export default Department;
